// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields, company} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (company) {
		for (let i = 0; i < fields.numberOfSignatories; i++) {
			if (fields['customer_signatory_firstname_' + i].length <= 0 ||
				fields['customer_signatory_lastname_' + i].length <= 0) {
				return false;
			}

			if (!Validator.validateEmail(fields['customer_signatory_email_' + i])) {
				return false;
			}
		}

		return !!(
			fields.customer_firstname.length > 0
			&& Validator.validateOrgNum(fields.customer_social_security_number, true)
			&& Validator.validateEmail(fields.customer_email)
		);
	}

	return !!(
		fields.customer_firstname.length > 0 &&
		fields.customer_lastname.length > 0 &&
		fields.customer_depot.length > 0 &&
		Validator.validateSsn(fields.customer_social_security_number, false) &&
		Validator.validateEmail(fields.customer_email)
	);
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/CustomerInformation/futur/CustomerInformation.fulfillment.js